import React from 'react'
import {useLocation, useNavigate} from 'react-router-dom'

import statistics from 'assets/statistics.svg'
import question from 'assets/question.svg'
import qr from 'assets/qr-white.svg'
import {useTranslation} from 'react-i18next'

const helpLink = 'https://nocoins.atlassian.net/servicedesk/customer/portals'

const navButtons = [
    {
        path: '/statistics',
        icon: statistics,
        label: 'NAVIGATION_STATISTICS',
    },
    {
        path: '/qr',
        icon: qr,
        label: 'NAVIGATION_QR',
    },
    {
        path: '/help',
        icon: question,
        label: 'NAVIGATION_HELP',
        link: helpLink,
    },
] as const

export const Navigation = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const onClickNavButton = (path: string) => () => {
        navigate(path)
    }
    const {t} = useTranslation()
    const selectedButton = location.pathname
    return (
        <div className="relative flex items-center justify-center gap-8 bg-yellow-40 py-3 xs:gap-5">
            {navButtons.map((nb, idx) =>
                'link' in nb ? (
                    <NavLink
                        key={idx}
                        isSelected={nb.path === selectedButton}
                        link={nb.link}
                    >
                        <img src={nb.icon} alt={nb.label} />
                        {t(nb.label)}
                    </NavLink>
                ) : (
                    <NavButton
                        key={idx}
                        isSelected={nb.path === selectedButton}
                        onClick={onClickNavButton(nb.path)}
                    >
                        <img src={nb.icon} alt={nb.label} />
                        {t(nb.label)}
                    </NavButton>
                ),
            )}
        </div>
    )
}

type NavButtonProps = {
    onClick: () => void
    isSelected: boolean
    children: React.ReactNode
}

const NavButton = ({isSelected, ...props}: NavButtonProps) => {
    return (
        <button
            className={`flex h-20 
                w-20 flex-col items-center justify-center 
                gap-1 rounded-full border-none bg-yellow-30
                text-2xs font-medium text-white 
                ${isSelected ? 'bg-yellow-10 shadow-y-inset' : 'shadow-y'} 
                hover:bg-yellow-10 active:bg-yellow-10 
                active:shadow-y-inset
            `}
            {...props}
        />
    )
}

type NavLinkProps = {
    link: string
    isSelected: boolean
    children: React.ReactNode
}
function NavLink({isSelected, link, children}: NavLinkProps) {
    return (
        <a
            className={`flex h-20 
                w-20 flex-col items-center justify-center 
                gap-1 rounded-full border-none bg-yellow-30
                text-2xs font-medium text-white 
                ${isSelected ? 'bg-yellow-10 shadow-y-inset' : 'shadow-y'} 
                hover:bg-yellow-10 active:bg-yellow-10 
                active:shadow-y-inset
            `}
            target="_blank"
            rel="noreferrer"
            href={link}
        >
            {children}
        </a>
    )
}
